
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-content",
      function () {
        return require("private-next-pages/partner-content.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-content"])
      });
    }
  